import { uniqueId } from 'lodash'
import { useEffect, useRef, useState } from 'react'
import { ControlSize } from 'types'
import { Container, Item } from './style'

type Props = {
    className?: string
    defaultIndex?: number
    disabled?: boolean
    labels: string[]
    size?: ControlSize
    onChange?: (index: number) => void
}

const Tabs = ({ className, defaultIndex = 0, disabled = false, labels, size = 'small', onChange }: Props) => {
    const idRef = useRef<string>(uniqueId('tab-control'))
    const [activeIndex, setActiveIndex] = useState<number>(defaultIndex)

    useEffect(() => {
        if (!disabled) {
            onChange?.(activeIndex)
        }
    }, [activeIndex, disabled])

    return (
        <Container $disabled={disabled || labels.length < 2} $size={size} className={className}>
            {labels.map((label, i) => (
                <Item
                    $active={!disabled && i === activeIndex}
                    key={`${idRef.current}-${i}`}
                    onClick={() => setActiveIndex(i)}
                >
                    <span>{label}</span>
                </Item>
            ))}
        </Container>
    )
}

export default Tabs
